import React from 'react';
import Section from '../Section';
import { ELIGIBILITY } from '../content';
import styles from './Eligibility.module.css';

function renderOptionalBreaks(text) {
  return text.split('\n').map((part, index, parts) => (
    <React.Fragment key={`${part}-${index}`}>
      {part}
      {index < parts.length - 1 && <br className={styles.optionalBreak} />}
    </React.Fragment>
  ));
}

// 「現在大学生／大学院生の方（年次問わず）」のような補足は小さく表示する。
function renderLabel(text) {
  const match = text.match(/^(.*?)(（.*）)$/s);
  if (!match) {
    return renderOptionalBreaks(text);
  }
  return (
    <>
      {renderOptionalBreaks(match[1])}
      <span className={styles.note}>{match[2]}</span>
    </>
  );
}

export default function Eligibility() {
  return (
    <Section id="eligibility">
      <div className={styles.panel}>
        <header className={styles.header}>
          <span className={styles.rule} aria-hidden="true" />
          <h2 className={styles.title}>募集対象</h2>
          <span className={styles.rule} aria-hidden="true" />
        </header>
        <ul className={styles.list}>
          {ELIGIBILITY.map(item => (
            <li key={item} className={styles.item}>
              {renderLabel(item)}
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
